import { toast } from "react-toastify";

const Toast = (type, message) => {
    toast(message, {
        position: 'top-right',
        theme: "colored",
        type: type,
        closeOnClick: true,
        pauseOnHover: true,
    });
}

export default Toast;